<template>
    <v-card>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <!-- omit in pdf display-->
                        <div v-if="!prop_pdf_display">
                            <h4 class="app-class-text-bold">
                                Facility Name
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_1" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <!-- omit in pdf display-->
                        <div>
                            <h4 class="app-class-text-bold">
                                Operations Officer
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_2" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                No Of Beds
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_15" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <div>
                            <h4 class="app-class-text-bold">
                                State
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_3" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                Salary Financer
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_4" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                Ownership
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_5" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <div>
                            <h4 class="app-class-text-bold">
                                LGA
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_6" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                Suppliers Financer
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_7" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <div>
                            <h4 class="app-class-text-bold">
                                Ward
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_8" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                Cachement Defined
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_9" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <div>
                            <h4 class="app-class-text-bold">
                                Ward Urbanity
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_10" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                Cachement Size
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_11" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <div>
                            <h4 class="app-class-text-bold">
                                Facility Type
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_12" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                Distance To State Capital (Dry)
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_13" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                Distance To State Capital (Rain)
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_14" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-card>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS
import ComponentColorCoderBool from '@/components/ComponentColorCoderBool';

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentGeneralInfo',

    props:[
        'prop_submission',
        'prop_pdf_display'
    ],

    components:{
        //GENERIC COMPONENTS
        ComponentColorCoderBool
    },

    data: function()
    {
        return {
        }
    },

    computed:{
        data_qst_1:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["FaciInf0002/parent10a"];
        },
        data_qst_2:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/GenInfo001/gen21"];
        },
        data_qst_3:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["FaciInf0002/parent53"];
        },
        data_qst_4:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/GenInfo001/gen19"];
        },
        data_qst_5:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/GenInfo001/gen18"];
        },
        data_qst_6:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["FaciInf0002/parent8"];
        },
        data_qst_7:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/GenInfo001/gen20"];
        },
        data_qst_8:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["FaciInf0002/parent9"];
        },
        data_qst_9:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/GenInfo001/gen27"];
        },
        data_qst_10:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["FaciInf0002/parent12"];
        },
        data_qst_11:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/GenInfo001/nuCatchAr/gen28"];
        },
        data_qst_12:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["FaciInf0002/parent52"];
        },
        data_qst_13:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/GenInfo001/gen25"];
        },
        data_qst_14:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/GenInfo001/gen26"];
        },
        data_qst_15:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/AdminSysInf/Infastructu/infra86"];
        },
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
